import React from 'react';
import Switch from 'react-switch';
import styled from 'styled-components';

export const GameSwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 26px;
  border-radius: 151px;
  border: 1px solid #e0e0e0;
  padding: 1.5px 16px;
`;

export const Label = styled.span<{ active: boolean }>`
  color: ${(props) => (props.active ? '#414141' : '#7b7b7b')};
  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: ${(props) => (props.active ? 700 : 400)};
  line-height: 21px;
`;

export const StyledSwitch = styled((props) => <Switch {...props} />)`
  &&& {
    margin: 2px auto;
  }
`;
